import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { select } from 'satcheljs/lib/legacy';
import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
export default select({
    optionState: function () { return store; },
    userOptions: function () {
        return getOptionsForFeature(OwsOptionsFeatureType.SurfaceActions);
    },
})(function isSurfaceActionsOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    return (isOptionDirty(getFallbackValueIfNull(optionState.readSurfaceActions, userOptions.readSurfaceActions), userOptions.readSurfaceActions) ||
        isOptionDirty(getFallbackValueIfNull(optionState.readSurfaceAddins, userOptions.readSurfaceAddins), userOptions.readSurfaceAddins) ||
        isOptionDirty(getFallbackValueIfNull(optionState.composeSurfaceActions, userOptions.composeSurfaceActions), userOptions.composeSurfaceActions) ||
        isOptionDirty(getFallbackValueIfNull(optionState.composeSurfaceAddins, userOptions.composeSurfaceAddins), userOptions.composeSurfaceAddins));
});
function isOptionDirty(optionState, userOption) {
    // For easy array comparison:
    // First, slice each array to create a copy so we don't modify the real data.
    // Second, sort them since order isn't important for this feature.
    // Third, join them to create a single string of all the actions/addins.
    // Finally, compare the strings.
    return (optionState
        .slice()
        .sort()
        .join() !==
        userOption
            .slice()
            .sort()
            .join());
}
//# sourceMappingURL=isSurfaceActionsOptionDirty.js.map